module.exports = __webpack_public_path__ + "static/media/icon.b5d56f8d.png";